import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import username from 'flarum/common/helpers/username';

/**
 * Replacement profile page between users a moderator has separated.
 * Deliberately shows nothing but the username and a generic message —
 * no unblock button, no hint about who set it.
 */
export default class SeparatedProfilePanel extends Component {
  view() {
    return (
      <div className="UserPage GhostBlock-page">
        <div className="Hero UserHero GhostBlock-hero">
          <div className="container">
            <div className="containerNarrow">
              <h2 className="Hero-title GhostBlock-username">{username(this.attrs.user)}</h2>
              <div className="GhostBlock-status">
                {app.translator.trans('happydigital-ghost-block.forum.profile.separated')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
